var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vue-number-input',{attrs:{"value":_vm.value,"min":1,"controls":"","center":"","size":"small"},on:{"change":_vm.onChange}})}
var staticRenderFns = []

export { render, staticRenderFns }